import React, { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import EarningDetails from "../../../Components/Earning/EarningDetails";
import Layout from "../../../Components/Layout";
import useHttpHook from "../../../Hooks/HttpHook";
import {
  OrganizerEarningDetails,
  OrganizerEarningOrdersDetails,
  OrganizerEarningPromoterDetails,
} from "../../../utils/ApiConstant";
import { createObjectForPaginatedResult } from "../../../utils/Helper";
import { toast } from "react-toastify";
import { showErrorToast } from "../../../utils/notify";

const EarningDetailsPage = () => {
  const { eventId } = useParams();
  const [details, setDetails] = useState({});
  const [orderDetails, setOrderDetails] = useState({});
  const [promoterDetails, setPromoterDetails] = useState({});

  const [loading, sendRequest, error] = useHttpHook();
  const query = new URLSearchParams(window.location.search);
  const [dataType, setDataType] = useState("ticket");
  const [timeSpanInput, setTimeSpanInput] = useState("");

  const redirectUrl = query.get("redirectUrl");

  useEffect(() => {
    if(dataType == 'order') {
      getOrderDetails();
    } else if(dataType == 'promoter') {
      getPromoterDetails();
    } else {
      getDetails();
    }
  }, [timeSpanInput,dataType]);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  const getDetails = async () => {
    try {
      const res = await sendRequest(
        `${OrganizerEarningDetails}/${eventId}?timeSpan=${timeSpanInput}`,
        {
          method: "get",
        }
      );

      if (res.status === 1) {
        setDetails(res.data);
      }
    } catch (error) {
      console.log({ error });
    }
  };

  const getPromoterDetails = async () => {
    try {
      const res = await sendRequest(
        `${OrganizerEarningPromoterDetails}/${eventId}?timeSpan=${timeSpanInput}`,
        {
          method: "get",
        }
      );

      if (res.status === 1) {
        setPromoterDetails(res.data);
      }
    } catch (error) {
      console.log({ error });
    }
  };

  const getOrderDetails = async (page = 1) => {
    try {
      const res = await sendRequest(
        `${OrganizerEarningOrdersDetails}/${eventId}?page=${page}&timeSpan=${timeSpanInput}`,
        {
          method: "get",
        }
      );
      if (res.status === 1) {
        if (page === 1) {
          setOrderDetails(res.data);
        } else {
          setOrderDetails((prevState) => {
            const data = createObjectForPaginatedResult(
              res.data.orderListing,
              prevState.orderListing
            );
            return {
              ...prevState,
              orderListing: data,
            };
          });
        }
      }
    } catch (error) {
      console.log({ error });
    }
  };

  const handleTimeSpan = (timeSpan) => {
    setTimeSpanInput(timeSpan);
  };

  return (
    <Layout Heading="Earning Details" TitleMark={true} TitleMarkClassName="event-earning-detail-title-mark" TitleClassName="event-earning-detail-title" HeadClassName="event-earning-detail-head" DetailsHead BackAction={redirectUrl} ExtraclassName="event-earning-detail-panel" activeMenuId="my-earnings">
      <EarningDetails
        isError={error}
        isLoading={loading}
        details={details}
        setDetails={setDetails}
        getDetails={getDetails}
        setDataType={setDataType}
        dataType={dataType}
        getOrderDetails={getOrderDetails}
        orderDetails={orderDetails}
        handleTimeSpan={handleTimeSpan}
        timeSpanInput={timeSpanInput}
        setTimeSpanInput={setTimeSpanInput}
        promoterDetails={promoterDetails}
      />
    </Layout>
  );
};

export default EarningDetailsPage;
